<div class="background-light-gray planning-steps-container">
    <div class="">
        <h3>The Steps to Prepare a Capital Reserve Plan</h3>
        <!-- <p class="font-light">Preparing a capital reserve plan is easier than you think.</p> -->
        <hr />
        <div class="planning-steps">
            <!-- STEP 1 -->
            <div class="step" [class.complete]="lastCompletedStep >= 1">
                <a [routerLink]="['/useraccount/components']">
                    <div class="bordered-circle">
                        <i *ngIf="lastCompletedStep >= 1" class="fa fa-check"></i>
                        <span *ngIf="lastCompletedStep < 1">1</span>
                    </div>
                    <div class="description">
                        Create or update <br />{{ 'component' | terminology | async }} inventory
                    </div>
                </a>
            </div>
            <div class="dots" [class.complete]="lastCompletedStep > 1">
                <i class="fa fa-circle"></i>
                <i class="fa fa-circle"></i>
                <i class="fa fa-circle"></i>
            </div>

            <!-- STEP 2 -->
            <div class="step" [class.complete]="lastCompletedStep >= 2">
                <a [routerLink]="['/useraccount/plans']">
                    <div class="bordered-circle">
                        <i *ngIf="lastCompletedStep >= 2" class="fa fa-check"></i>
                        <span *ngIf="lastCompletedStep < 2">2</span>
                    </div>
                    <div class="description">
                        Create and compare<br />funding plans
                    </div>
                </a>
            </div>
            <div class="dots" [class.complete]="lastCompletedStep > 2">
                <i class="fa fa-circle"></i>
                <i class="fa fa-circle"></i>
                <i class="fa fa-circle"></i>
            </div>

            <!-- STEP 3 -->
            <div class="step" [class.complete]="lastCompletedStep >= 3">
                <a [routerLink]="['/useraccount/reports/reserve-analysis']" [queryParams]="{showSettings: true}">
                    <div class="bordered-circle">
                        <i *ngIf="lastCompletedStep >= 3" class="fa fa-check"></i>
                        <span *ngIf="lastCompletedStep < 3">3</span>
                    </div>
                    <div class="description">
                        Select recommended <br />funding plan
                    </div>
                </a>
            </div>
            <div class="dots" [class.complete]="lastCompletedStep > 3" *ngIf="showDisclosureStep || showFinalizeStep">
                <i class="fa fa-circle"></i>
                <i class="fa fa-circle"></i>
                <i class="fa fa-circle"></i>
            </div>

            <!-- STEP 4 -->
            <div class="step" [class.complete]="lastCompletedStep >= 4" *ngIf="showDisclosureStep">
                <a [routerLink]="['/useraccount/reports/disclosure']">
                    <div class="bordered-circle">
                        <i *ngIf="lastCompletedStep >= 4" class="fa fa-check"></i>
                        <span *ngIf="lastCompletedStep < 4">4</span>
                    </div>
                    <div class="description">
                        Generate disclosure <br />report
                    </div>
                </a>
            </div>
            <div class="dots" [class.complete]="lastCompletedStep > 4" *ngIf="showDisclosureStep && showFinalizeStep">
                <i class="fa fa-circle"></i>
                <i class="fa fa-circle"></i>
                <i class="fa fa-circle"></i>
            </div>

            <!-- STEP 5 -->
            <div class="step" [class.complete]="lastCompletedStep >= 5" *ngIf="showFinalizeStep">
                <a [routerLink]="" (mouseenter)="showFinalizePopover($event)" (mouseleave)="hideFinalizePopover()">
                    <div class="bordered-circle">
                        <i *ngIf="lastCompletedStep >= 5" class="fa fa-check"></i>
                        <i *ngIf="lastCompletedStep < 5 && !showFinalizeStep" class="fa fa-lock locked"></i>
                        <span *ngIf="lastCompletedStep < 5 && showFinalizeStep">{{ showDisclosureStep ? '5' : '4'}}</span>
                    </div>
                    <div class="description">
                        Advance to next planning year
                    </div>
                </a>
            </div>
        </div>
    </div>
    <dx-popover 
        #finalizePopover
        [(target)]="finalizePopoverTarget" 
        position="bottom"
        [showTitle]="true"
        title="Advance to next planning year"
        (onHiding)="onFinalizePopoverHiding($event)"
        (onContentReady)="onFinalizePopoverContentReady($event)">
        <div *dxTemplate="let data = model; of: 'content'">
            <div class="step-popover-body">
                <div *ngIf="showFinalizeStep">
                    Advance to next planning year by clicking the <button type="button" class="btn btn-primary-inverse disable">Advance</button> button in the yellow banner at the top of the page and following the directions.
                </div>

                <div *ngIf="!showFinalizeStep">
                    You can advance to planning the {{nextFiscalYearDisplay}} fiscal year after the next fiscal year begins on {{selectedFiscalYearStartDate | date: 'M/d/yyyy'}}.
                </div>
            </div>
        </div>
    </dx-popover>
</div>
